import React from 'react';
import { clsx } from 'clsx';

interface TableHeaderProps extends React.HTMLAttributes<HTMLTableSectionElement> {
  children: React.ReactNode;
}

export function TableHeader({ children, className, ...props }: TableHeaderProps) {
  return (
    <thead 
      className={clsx("bg-gray-50", className)} 
      {...props}
    >
      {children}
    </thead>
  );
} 